import i18ninit from './i18n';
import { createApp } from './createApp';
import config from './temp/config';
import gsap from 'gsap';
import { APP_CONST } from '@/utils/constants';
import { isNoE } from '@/utils/obj-utils';
import { loadChineseFont } from '@/utils/dom-utils';
import { Workbox } from 'workbox-window';
import { eq } from '@/utils/string-utils';

import api from '@/api';
import { getLangFromUrl, getQueryStrings } from '@/utils/uri-utils';
import * as Vue from 'vue/dist/vue.esm-bundler';
let initLanguage = config.defaultLanguage;

/*
  SSR Data
  If we're running in a server-side rendering scenario,
  the server will provide the window.__JSS_STATE__ object
  for us to acquire the initial state to run with on the client.

  This enables us to skip a network request to load up the layout data.

  SSR is initiated from /server/server.js.
*/
APP_CONST.lang = initLanguage;

let __JSS_STATE__ = null;
const ssrRawJson = document.getElementById('__JSS_STATE__');
if (ssrRawJson) {
  __JSS_STATE__ = JSON.parse(ssrRawJson.innerHTML);
}
initLanguage = __JSS_STATE__?.sitecore?.context?.language ?? getLangFromUrl();
APP_CONST.lang = initLanguage;
if (/^zh/gi.test(initLanguage)) {
  loadChineseFont();
}
if (navigator.serviceWorker && process.env.NODE_ENV !== 'development') {
  // Use BASE_URL (derived from PUBLIC_URL=/dist/probio-portal) so the SW path matches
  // where vue-cli-plugin-pwa emits service-worker.js in the production build.
  const swUrl = `${process.env.BASE_URL}service-worker.js`;
  const wb = new Workbox(swUrl);
  wb.register()
    .then(() => {
      console.log('Service Worker Registered');
    })
    .catch((swErr) => console.log(`Service Worker Installation Error: ${swErr}}`));
}
// initialize the dictionary, then render the app
// note: if not making a multlingual app, the dictionary init can be removed.
Promise.all([i18ninit(initLanguage)]).then(([i18n]) => {
  // HTML element to place the app into
  const rootElement = document.getElementById('root');
  const initialState = __JSS_STATE__ || null;
  const { app } = createApp(initialState, i18n);
  global.Vue = Vue;
  app.mount(rootElement);
  // const $rootLoading = document.getElementById('root-loading');
  // if ($rootLoading.style.display !== 'none') {
  //   gsap.to($rootLoading, {
  //     opacity: 0,
  //     duration: 0.2,
  //     onComplete() {
  //       $rootLoading.style.display = 'none';
  //     }
  //   });
  // }
});
